// src/modules/app-views/offers/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';
import { generateUidV4 } from 'utils/helpers';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  types: [
    {
      uid: generateUidV4(),
      name: 'Genérico',
      description: 'Tipo genérico de oferta',
    },
  ],
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedOffersParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];
  const results = [];

  // Seed types if none exist
  const typesResult = await seedCategory({
    moduleId,
    category: 'types',
    currentData: moduleParams?.types,
    defaultData: DEFAULT_SEEDS.types,
  });
  if (typesResult) results.push(typesResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedOffersParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function checkHasActiveItems(dataArray) {
  if (!dataArray || !Array.isArray(dataArray)) return false;
  return dataArray.some(item => !item.removed);
}

async function seedCategory({ moduleId, category, currentData, defaultData }) {
  const hasActiveItems = checkHasActiveItems(currentData);

  if (hasActiveItems) {
    return null; // Already has data, skip seeding
  }

  try {
    await appService.updateModulePreferences({
      category,
      moduleId,
      data: defaultData,
    });

    return { category, seeded: true, data: defaultData };
  } catch (error) {
    console.error(`[seedOffersParameters] Error seeding ${category}:`, error);
    return { category, seeded: false, error };
  }
}
